export default __webpack_public_path__ + "static/media/arrow-down.287e0971.svg";